<template>
    <div class="demo-collapse">
        <h2 class="van-doc-demo-block__title">热点问题</h2>
        <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="如何申请教练？" name="1" class="answer">
                用户登录账号，在“我的”里面可以看到教练申请入口。
            </van-collapse-item>
            <van-collapse-item title="怎么提高自己的等级？" name="2" class="answer">
                每天登录网站练习，还可以学习课程累计时间等。
            </van-collapse-item>
            <van-collapse-item title="如何发布课程？" name="3" class="answer">
                请前往电脑端管理后台，http://www.buole.com/admin，进行课程发布和课程管理。
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
import Vue from "vue";
import { Collapse, CollapseItem } from 'vant';

Vue.use(Collapse).use(CollapseItem);

export default {
    name: 'Help',
    data() {
      return {
          activeNames: ['1']
      }
    },
    created() {
    
    }
}
</script>
<style lang="less" scoped>
body{
    background-color: white;
}
.van-doc-demo-block__title {
    margin: 0;
    font-weight: 400;
    font-size: 0.14rem;
    color: rgba(69,90,100,.6);
    padding: 0.12rem 0.15rem 0.12rem;
}
.demo-collapse .answer{
    font-size: 0.14rem;
    color: #999;
}
</style>



// WEBPACK FOOTER //
// src/pages/Help.vue